<template>
  <DpplSvg
    v-if="specificityLabel === 'Small' || specificityLabel === 'Small Local'"
    file-name="icon-specificity-small"
  />
  <DpplSvg
    v-else-if="specificityLabel === 'Medium'"
    file-name="icon-specificity-medium"
  />
  <DpplSvg
    v-else-if="specificityLabel === 'Large'"
    file-name="icon-specificity-large"
  />
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

defineProps({
  specificityLabel: {
    type: String,
    required: true,
  },
});
</script>
